// import tracking from './tracking'
import validator from './type_validator'
import formSubmission from './form_submission'
import contactForms from './contactForms'
import newsletter from './newsletter'

export const initListeners = () => {
  let testArray = [],
    errorMsg = document.querySelector(".error-msg"),
    concession = document.querySelector("#dealer")

  return {
    setFocus: (input, withValidation) => {
      /**
      input.addEventListener('change', e => {
        validator().checkType(e.currentTarget)
      })**/
      input.addEventListener("focus", e=> {
        e.currentTarget.parentElement.classList.add("focus")
      })
      input.addEventListener("blur", e=>{
            e.currentTarget.parentElement.classList.remove("focus");
            e.currentTarget.value ? e.currentTarget.parentElement.classList.add("not-null") : e.currentTarget.parentElement.classList.remove("not-null")
      });
    },

    setRadioChange: (input, form, btnSerie) => {
      input.addEventListener('change', e => {
        let radioArray = document.querySelectorAll(
          `input[name='${e.currentTarget.name}']`
        )
        for (let y = 0; y < radioArray.length; y++) {
          radioArray[y].checked = false
          btnSerie[y].classList.remove('checked')
        }
        e.currentTarget.checked = true
        form
          .querySelector(`label[for='${e.currentTarget.id}']`)
          .classList.add('checked')
      })
    },

    setSelectChange: select => {
      let selectLabel = select.querySelector(".select-label")

      document.body.addEventListener('click', e =>{
        let selectChildrenArr = Array.from(select.querySelectorAll("li"))
        if(select.classList.contains('opened'))
        {
          select.classList.remove('opened')
          selectChildrenArr.forEach(element => {
            element.classList.remove('show')
          })
          // e.stopPropagation()
        }
      }, false)

      selectLabel.addEventListener('click', e => {

        e.currentTarget.parentElement.classList.remove('error')
        e.currentTarget.parentElement.parentElement.classList.remove('error')
        let selectChildrenArr = Array.from(select.querySelectorAll('li'))
        select.classList.toggle('opened')
        selectChildrenArr.forEach(element => {
          if(select.classList.contains('opened'))
          {
            element.classList.add('show')
            element.addEventListener('click', e => {
              let value = e.currentTarget.getAttribute('data-value'),
              selectedId = e.currentTarget.getAttribute('data-id'),
              selectedBrand = e.currentTarget.getAttribute('data-brand')
              selectLabel.setAttribute('data-value', value)
              selectLabel.setAttribute('data-id', selectedId)
              selectLabel.setAttribute('data-brand', selectedBrand)
              selectLabel.innerHTML = `${value}`
              select.classList.remove('opened')
              select.classList.add('correct')
              selectChildrenArr.forEach(element => {
                element.classList.remove('show')
              })

              if(selectLabel.id == 'subscriber-type' && document.querySelector(".page__form").querySelector(".form").classList.contains("form__rfc-franchise"))
              {
                let msgField = document.querySelector('.form__input--message ')
                if(msgField)
                {
                  msgField.value = value + " - "
                }

              }


            })
          }

          else
          {
            element.classList.remove('show')
          }

        })

        e.stopPropagation()
      })


    },

    setKeypress: input => {
      input.addEventListener('keypress', e => {
        // validator().checkType(e.currentTarget)
        if (e.charCode != 13) {
          return validator().isNumber(e)
        }
      })
    },

    setSubmit: (input, array, form) => {
      input.addEventListener('click', e => {
        e.preventDefault()
        testArray.length = 0
        if (form.classList.contains('form__centered')) {
          let civilityLabel = form.querySelector(
            ".civility-option.select-label"
          )
          if (civilityLabel) {
            validator().validateTypeSelect(civilityLabel, testArray)
          }
        }
        if (form.classList.contains('form__contact')) {
          let objectLabel = form.querySelector(".object-label")
          validator().validateTypeSelect(objectLabel, testArray)
          let isCustomerRadioField = form.querySelector('.form__input-container__is_customer_select');
          if (isCustomerRadioField) {
            let radioGroup = form.querySelectorAll('input[type="radio"][name="customer"]');
            let customerLabel = form.querySelector(".is-customer-option")
            validator().validateTypeRadio(radioGroup, customerLabel, testArray)
          }
        }

        if (form.classList.contains('form__newsletter')) {
          let newsletterSubjectField = form.querySelector('.form__input-container__newsletter_select');
          if (newsletterSubjectField) {
            let checkboxGroup = form.querySelectorAll('input[type="checkbox"][name="newsletter_subject"]');
            validator().validateTypeRadio(checkboxGroup, newsletterSubjectField, testArray)
          }
        }

        if (form.classList.contains('form__rfc')) {
            let objectLabels = form.querySelectorAll(".select-label__required")
            if(objectLabels) {
              objectLabels.forEach(objectLabel => {
                validator().validateTypeSelect(objectLabel, testArray)
              })
            }
          }
        if (form.classList.contains('form__rfc-franchise')) {
          let objectLabels = form.querySelectorAll(".object-label__required")
          if(objectLabels) {
            objectLabels.forEach(objectLabel => {
              validator().validateTypeSelect(objectLabel, testArray)
            })
          }
        }
        if (form)
          array.forEach(input => {
            if (input.classList.contains('required')) {
                // console.log(input);
                // console.log(validator().checkType(input));
              testArray.push(validator().checkType(input))
            }
          })

        if (testArray.indexOf(false) >= 0) {
          errorMsg.classList.remove("no-error")
          if(document.querySelector(".error") && document.querySelector(".error").offsetParent) {
            window.scrollTo(
              0,
              document.querySelector(".error").offsetParent.offsetTop
            )
          }
        } else {
          errorMsg.classList.add('no-error')
          input.classList.add('disabled')
          input.disabled = true
          if (concession) {
            if (
              !concession.classList.contains("displayed") &&
              concession.value.length > 0
            ) {
              formSubmission()
            } else {
              concession.parentElement.classList.add('error')
            }
          } else if (form.classList.contains('form__contact')) {
            contactForms().formSubmission()
          } else if (form.classList.contains('form__newsletter')) {
            newsletter().formSubmission()
          } else {
            formSubmission()
          }
        }
      })
    }
  }
}
